import styled from 'styled-components';

export const List = styled.ul`
  font-size: 14px;
  line-height: 2;
`;
